import { connect } from "react-redux";
import { fetchCountry } from "../../actions/CountrySelector";
import { setReturnFocus, toggleSelector } from "../../actions/Modal";
import CountrySelector from "../../components/CountrySelector/index.jsx";

const mapStateToProps = (state) => ({
  countryData: state.CountrySelector.countryData,
  buttonData: state.CountrySelector.buttonData,
  isVisible: state.CountrySelector.isVisible,
  premierCountrySelector: state.PremierPageFrame.content.premierCountrySelector,
  assetsUrl: state.Environment.assetsUrl,
});

const mapDispatchToProps = (dispatch) => ({
  updateCountry: (returnFocus) => {
    dispatch(setReturnFocus(returnFocus));
    dispatch(toggleSelector());
  },
  fetchCountry: (country, language, currency) => {
    dispatch(fetchCountry(country, language, currency));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelector);
